import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { RestPlantService } from 'src/app/service/rest/plant/rest-plant.service';
import { PageDialogService } from 'src/app/service/utils/page-dialog.service';
import { PageService } from 'src/app/service/utils/page.service';
import { TranslateFirebaseService } from 'src/app/service/utils/translate-firebase.service';
import { AllowedUser, PlantOwner } from '../user/user.model';
import { UserService } from '../user/user.service';
import {
  AddPlantFromDeviceType,
  OwnerAuthorization,
  Plant,
} from './plant.model';
import { PlantService } from './plant.service';

export const USER_PLANTS_STORAGE_KEY = 'Upservice-user-plants';

@Injectable()
export class PlantRepositoryService {
  private _plants: Plant[] = [];
  plantsLoaded: boolean = false;

  constructor(
    private plantService: PlantService,
    private plantRest: RestPlantService,
    private pageService: PageService,
    private pageDialogService: PageDialogService,
    private translate: TranslateFirebaseService,
    private router: Router,
    private userService: UserService
  ) {
    //if (!this.plantsLoaded) this.loadPlants();
  }

  public get plants(): Plant[] {
    let data: Plant[] = JSON.parse(
      sessionStorage.getItem(USER_PLANTS_STORAGE_KEY)
    );
    if (this._plants.length == 0 && !this.plantsLoaded && data) {
      data.forEach((plant: Plant) => {
        if (plant.tags) {
          if (
            plant.tags.find((tag) => tag.key?.toLowerCase() == 'creationdate')
          ) {
            plant.creationDate = new Date(
              plant.tags.find(
                (tag) => tag.key.toLowerCase() == 'creationdate'
              ).value
            );
          }
          if (plant.tags.find((tag) => tag.key?.toLowerCase() == 'companyname'))
            plant.companyName = plant.tags.find(
              (tag) => tag.key.toLowerCase() == 'companyname'
            ).value;
          if (plant.tags.find((tag) => tag.key?.toLowerCase() == 'planttype'))
            plant.type = plant.tags.find(
              (tag) => tag.key.toLowerCase() == 'planttype'
            ).value;
        }

        if (!plant.creationDate) plant.creationDate = new Date();
      });

      this.plants = data;

      this.loadPlants();

      return data;
    } else return this._plants;
  }

  public set plants(value: Plant[]) {
    sessionStorage.setItem(USER_PLANTS_STORAGE_KEY, JSON.stringify(value));
    this._plants = value;
  }

  getPlants(): Plant[] {
    if (!this.plantsLoaded) this.loadPlants();

    return this.plants;
  }

  private loadPlants() {
    //TODO COMPANY NAME quando sarà presente come parametro non ci sarà bisogno di salvare in tag
    this.plantRest.getPlantsList().subscribe(
      (plants: Plant[]) => {
        if (plants) {
          this.plants = [];
          plants.forEach((plant: Plant) => {
            if (plant.tags) {
              if (
                plant.tags.find(
                  (tag) => tag.key && tag.key.toLowerCase() == 'creationdate'
                )
              ) {
                plant.creationDate = new Date(
                  plant.tags.find(
                    (tag) => tag.key.toLowerCase() == 'creationdate'
                  ).value
                );
              }
              if (
                plant.tags.find(
                  (tag) => tag.key && tag.key.toLowerCase() == 'companyname'
                )
              )
                plant.companyName = plant.tags.find(
                  (tag) => tag.key.toLowerCase() == 'companyname'
                ).value;
              if (
                plant.tags.find(
                  (tag) => tag.key && tag.key.toLowerCase() == 'planttype'
                )
              )
                plant.type = plant.tags.find(
                  (tag) => tag.key.toLowerCase() == 'planttype'
                ).value;
            }
            if (!plant.creationDate) plant.creationDate = new Date();
          });
          this.plants = plants;
          this.plantsLoaded = true;
        }
      },
      (error) => {
        if (error.status == 401) this.router.navigateByUrl('/prelogin');
        console.log(error.status);
      }
    );
  }

  createPlant(plant: Plant) {
    this.plantRest.createPlant(plant).subscribe(
      (result: Plant) => {
        if (result) {
          if (
            this.pageDialogService.addPlantFromDevice !=
            AddPlantFromDeviceType.NONE
          ) {
            this.pageDialogService.plantId = result.id;
            this.pageDialogService.addPlant = false;
            if (
              this.pageDialogService.addPlantFromDevice ==
              AddPlantFromDeviceType.ADD
            ) {
              this.pageDialogService.dialogTitle = 'add_device_title';
              this.pageDialogService.addDevice = true;
            } else if (
              this.pageDialogService.addPlantFromDevice ==
              AddPlantFromDeviceType.EDIT
            ) {
              this.pageDialogService.dialogTitle = 'edit_device_title';
              this.pageDialogService.editDevice = true;
            }
            this.pageDialogService.addPlantFromDevice =
              AddPlantFromDeviceType.NONE;
          }
          this.pageService.openSnackBar(
            this.translate.getTranslation('add_plant_success'),
            'Ok'
          );
          result.creationDate = new Date();
          result.creationDate.setHours(0, 0, 0, 0);
          if (result.tags.find((tag) => tag.key.toLowerCase() == 'companyname'))
            result.companyName = result.tags.find(
              (tag) => tag.key.toLowerCase() == 'companyname'
            ).value;
          this.plants.push(result);
          sessionStorage.setItem(
            USER_PLANTS_STORAGE_KEY,
            JSON.stringify(this.plants)
          );
        }
      },
      (error) => {
        this.pageService.openErrorSnackBar(
          this.translate.getTranslation('add_plant_failed'),
          'Ok'
        );
        console.log(error.status);
      }
    );
  }

  updatePlant(plant: Plant) {
    this.plantRest.updatePlant(plant).subscribe(
      (result: string) => {
        this.pageService.openSnackBar(
          this.translate.getTranslation('update_plant_success'),
          'Ok'
        );
        const index: number = this.plants
          .map((plant) => plant.id)
          .indexOf(plant.id);
        this.plantService.plant = plant;
        this.plants[index] = plant;
        sessionStorage.setItem(
          USER_PLANTS_STORAGE_KEY,
          JSON.stringify(this.plants)
        );
      },
      (error) => {
        this.pageService.openErrorSnackBar(
          this.translate.getTranslation('update_plant_failed'),
          'Ok'
        );
        console.log(error.status);
      }
    );
  }

  deletePlant(plant: Plant) {
    this.plantRest.deletePlant(plant.id).subscribe(
      (result) => {
        this.pageService.openSnackBar(
          this.translate.getTranslation('delete_plant_success'),
          'Ok'
        );
        const index = this.plants.map((plant) => plant.id).indexOf(plant.id);
        if (index > -1) this.plants.splice(index, 1);
        sessionStorage.setItem(
          USER_PLANTS_STORAGE_KEY,
          JSON.stringify(this.plants)
        );
      },
      (error) => {
        this.pageService.openErrorSnackBar(
          this.translate.getTranslation('delete_plant_failed'),
          'Ok'
        );
        console.log(error.status);
      }
    );
  }

  getPlantById(id: string) {
    if (this.plantsLoaded) {
      let plant: Plant = this.plants.find((plant: Plant) => plant.id == id);
      this.plantService.plant = plant;
    } else
      this.plantRest.getPlant(id).subscribe((result) => {
        this.plantService.plant = result;
      });
  }

  getPlantsByDate(date: Date): Plant[] {
    return this.plants.filter(
      (plant) =>
        date == undefined ||
        plant.creationDate.setHours(0, 0, 0) == date.setHours(0, 0, 0)
    );
  }

  getPlantDates(order: boolean) {
    //IF order == true newest to oldest, else oldest to newest
    if (order)
      return this.plants
        .map((plant) => plant.creationDate ? new Date(plant.creationDate) : null)
        .filter((date) => date !== null)
        .filter(
          (ele, index, array) =>
            array.findIndex(
              (i) => i.setHours(0, 0, 0, 0) == ele.setHours(0, 0, 0, 0)
            ) == index
        )
        .sort((a, b) => (a > b ? -1 : 1));
    else
      return this.plants
        .map((plant) => plant.creationDate ? new Date(plant.creationDate) : null)
        .filter((date) => date !== null)
        .filter(
          (ele, index, array) =>
            array.findIndex(
              (i) => i.setHours(0, 0, 0, 0) == ele.setHours(0, 0, 0, 0)
            ) == index
        )
        .sort((a, b) => (a > b ? 1 : -1));
  }

  getPlantsChars(ascending: boolean) {
    if (ascending)
      return this.plants
        .map((plant) => plant.name.toLowerCase().charAt(0))
        .filter((ele, index, array) => array.indexOf(ele) == index)
        .sort((a, b) => (a > b ? 1 : -1));
    else
      return this.plants
        .map((plant) => plant.name.toLowerCase().charAt(0))
        .filter((ele, index, array) => array.indexOf(ele) == index)
        .sort((a, b) => (a > b ? -1 : 1));
  }

  getPlantsByChar(char: string): Plant[] {
    return this.plants.filter(
      (plant) =>
        char == undefined ||
        plant.name.toLowerCase().charAt(0) == char.toLowerCase()
    );
  }

  getPlantsAllowedUsers(ascending: boolean): AllowedUser[] {
    let totalAllowedUsers: AllowedUser[] = [];
    let allowedUsersArray = this.plants.map((plant) => plant.allowedUsers);
    allowedUsersArray.forEach((plantAllowedUsers) => {
      if (plantAllowedUsers)
        plantAllowedUsers.forEach((user: AllowedUser) => {
          if (totalAllowedUsers.indexOf(user) == -1)
            totalAllowedUsers.push(user);
        });
    });

    if (ascending) return totalAllowedUsers.sort((a, b) => (a > b ? 1 : -1));
    else return totalAllowedUsers.sort((a, b) => (a > b ? -1 : 1));
  }

  getPlantsOwners(ascending: boolean): PlantOwner[] {
    let totalOwners: PlantOwner[] = [];
    let ownerArray: PlantOwner[] = this.plants.map((plant) => {
      return new PlantOwner(plant.ownerId, plant.ownerEmail);
    });

    ownerArray.forEach((plantOwner: PlantOwner) => {
      if (
        plantOwner.ownerId !== this.userService.upsUser.oid &&
        totalOwners.findIndex((po) => po.ownerId == plantOwner.ownerId) == -1
      )
        totalOwners.push(plantOwner);
    });

    if (ascending) return totalOwners.sort((a, b) => (a > b ? 1 : -1));
    else return totalOwners.sort((a, b) => (a > b ? -1 : 1));
  }

  getPlantsByAllowedUser(allowedUser: AllowedUser): Plant[] {
    return this.plants.filter(
      (plant) =>
        plant.allowedUsers && plant.allowedUsers.indexOf(allowedUser) > -1
    );
  }

  getPlantsByOwner(owner: PlantOwner): Plant[] {
    return this.plants
      .filter((plant) => plant.ownerId === owner.ownerId)
      .sort((a: Plant, b: Plant) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      );
  }

  getPlantsAsOwner(): Plant[] {
    return this.plants
      .filter((plant) => plant.ownerId === this.userService.upsUser.oid)
      .sort((a: Plant, b: Plant) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      );
  }

  sharePlant(id: string, email: string) {
    return this.plantRest.inviteUserOnPlant(id, email);
  }

  unsharePlant(id: string, email: string): Observable<any> {
    return this.plantRest.removeUserFromPlant(id, email);
  }

  changeOwner(id: string, email: string, authorization: OwnerAuthorization) {
    return this.plantRest.changePlantOwner(id, email, authorization);
  }

  getPlantName(id: string): string {
    let plant: Plant = this.plants.find((plant: Plant) => plant.id == id);
    if (plant) return plant?.name;
    else return '';
  }

  getPlantCountry(id: string): string {
    let plant: Plant = this.plants.find((plant: Plant) => plant.id == id);
    if (plant) return plant?.country;
    else return '';
  }
}
